import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../axiosInstance';

const VisitCountdown = () => {
  const { slug } = useParams();
  const [countdown, setCountdown] = useState(10);
  const [credited, setCredited] = useState(false);
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  // === COUNTDOWN LOGIC ===
  useEffect(() => {
    if (countdown <= 0) {
      axios.post(`/api/visit/${slug}/credit`)
        .then(res => {
          setMessage(res.data.message);
          setCredited(true);
        })
        .catch(err => {
          setMessage("An error occurred.");
          console.error(err);
        });
      return;
    }

    const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, slug]);

  // === NOUVEAU AADS ADAPTATIF (mobile + desktop) ===
  useEffect(() => {
    const div = document.createElement("div");
    div.innerHTML = `
      <!-- BEGIN AADS AD UNIT 2425494 -->
      
      <!-- END AADS AD UNIT 2425494 -->
    `;
    document.body.appendChild(div);
    return () => document.body.removeChild(div);
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans overflow-hidden">
      {/* NAVBAR - identique à toutes les autres pages */}
      <header className="bg-gray-900/95 backdrop-blur-xl border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl 2xl:max-w-none mx-auto px-4 sm:px-6 2xl:px-10 py-4 sm:py-5">
          <div className="flex items-center justify-between">
            
            {/* Logo + Hamburger (visible seulement mobile) */}
            <div className="flex items-center gap-4">
              <img 
                src="/bannerRank.png" 
                alt="RankMyBanner" 
                className="h-9 sm:h-10 w-auto drop-shadow-[0_0_15px_rgb(16,185,129)]" 
              />
              
              {/* Hamburger - visible < md */}
              <button 
                type="button" 
                className="md:hidden text-emerald-400 focus:outline-none"
                aria-label="Toggle menu"
                onClick={() => setIsOpen(!isOpen)}
              >
                {/* SVG hamburger ou croix selon isOpen */}
                  {isOpen ? (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
              </button>
            </div>

            {/* Navigation */}
            <nav
                  className={`
                    ${isOpen ? 'block' : 'hidden'}              // affiche/cache sur mobile quand on clique
                    md:flex md:items-center                     // sur desktop → toujours visible + flex horizontal
                    absolute md:static top-full left-0 right-0  // position absolute sur mobile pour dropdown
                    bg-gray-900/95 md:bg-transparent            // fond sombre sur mobile, transparent sur desktop
                    border-b border-gray-800 md:border-none     // bordure basse sur mobile uniquement
                    p-6 md:p-0                                  // padding plus important sur mobile
                    flex flex-col md:flex-row                   // colonne sur mobile, ligne sur desktop
                    gap-6 md:gap-x-8 md:gap-y-0                 // espacement adapté
                    text-sm font-medium                         // style texte
                    z-40                                        // au-dessus du reste si besoin
                  `}
                >
              <a href="/" className="hover:text-emerald-400 transition hover:text-emerald-300">Home</a>
              <a href="/leaderboard" className="hover:text-emerald-400 font-semibold transition">Leaderboard</a>
              <a href="/submit" className="text-emerald-400 transition">Submit Your Banner</a>
              <a href="/claim" className="hover:text-emerald-400 transition">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-emerald-400 transition">How to Increase</a>
            </nav>

            {/* Pub – cachée sur < 2xl */}
            <div className="hidden 2xl:block flex-shrink-0">
              <iframe 
                src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
                width="728" 
                height="90" 
                scrolling="no" 
                border="0" 
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </header>

      {/* MAIN COUNTDOWN SECTION */}
      <main className="flex-1 flex items-center justify-center py-24 px-6 bg-black">
        <div className="max-w-2xl w-full text-center">
          {!credited ? (
            <>
              {/* Intro Card */}
              <div className="bg-gray-900 border border-gray-800 rounded-3xl p-10 mb-10">
                <h2 className="text-3xl font-bold mb-4 text-emerald-400">You are helping a banner earn points!</h2>
                <p className="text-gray-400 text-lg">
                  Each unique visit counts. Thank you for supporting creators on RankMyBanner.
                </p>
              </div>

              {/* COUNTDOWN - neon style */}
              <div className="bg-gray-950 border border-emerald-500/30 rounded-3xl p-16 shadow-[0_0_60px_rgb(16,185,129,0.2)]">
                <p className="text-emerald-400 text-sm tracking-[4px] uppercase mb-4">Your visit is being counted...</p>
                <div className="text-[120px] font-black text-white tracking-[-8px] tabular-nums">
                  {countdown}
                </div>
                <p className="text-2xl text-gray-400">seconds</p>
              </div>
            </>
          ) : (
            <>
              {/* SUCCESS SCREEN */}
              <div className="bg-emerald-950 border border-emerald-500/50 rounded-3xl p-16 text-center">
                <div className="text-8xl mb-6">✅</div>
                <h1 className="text-5xl font-black text-emerald-400 mb-6">THANK YOU!</h1>
                <p className="text-2xl text-gray-300 mb-8">{message}</p>
                
                <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 mb-10">
                  <p className="text-gray-400 text-lg">
                    You've successfully helped this banner climb the rankings. 
                    The more active banners are, the more traffic they receive!
                  </p>
                </div>

                <Link
                  to="/submit"
                  className="inline-block px-14 py-6 bg-gradient-to-r from-emerald-500 to-teal-500 text-xl font-bold rounded-3xl hover:scale-105 transition-all shadow-[0_0_40px_rgb(16,185,129)]"
                >
                  SUBMIT YOUR OWN BANNER →
                </Link>
              </div>
            </>
          )}
        </div>
      </main>

      {/* ZeroAds bottom banner */}
      <div className="flex justify-center py-12 bg-gray-900">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" height="90" scrolling="no" border="0" frameBorder="0"
        />
      </div>

      {/* FINAL CTA */}
      <div className="py-20 bg-gradient-to-r from-emerald-950 via-black to-teal-950 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-5xl font-black tracking-tight mb-6">Want your own banner to grow?</h2>
          <Link
            to="/submit"
            className="inline-block px-16 py-7 text-2xl font-bold bg-white text-black rounded-3xl hover:bg-emerald-400 hover:text-black transition-all scale-105 shadow-[0_0_60px_rgb(16,185,129)]"
          >
            SUBMIT NOW &amp; START EARNING
          </Link>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-gray-500">
            <div>© 2026 RankMyBanner • All Rights Reserved</div>
            <div className="flex gap-8">
              <a href="/" className="hover:text-gray-300">Home</a>
              <a href="/leaderboard" className="hover:text-gray-300">Leaderboard</a>
              <a href="/submit" className="hover:text-gray-300">Submit Your Banner</a>
              <a href="/claim" className="hover:text-gray-300">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-gray-300">How to Increase</a>
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VisitCountdown;